import { get, post, put, del } from './http';

export interface Announcement {
  id: string;
  title: string;
  content: string;
  type: 'info' | 'warning' | 'success' | 'event';
  publishedAt: string;
  expiresAt?: string;
  active: boolean;
  createdBy: string;
  targetRole: 'all' | 'vip' | 'member';
}

export interface AnnouncementCenterItem extends Announcement {
  read: boolean;
}

export interface AnnouncementPayload {
  title: string;
  content: string;
  type: 'info' | 'warning' | 'success' | 'event';
  targetRole: 'all' | 'vip' | 'member';
  expiresAt?: string;
}

// 1. 会员获取展示中的公告
export function getAnnouncements() {
  return get<Announcement[]>('/announcements');
}

// 1.1 会员获取公告中心列表
export function getAnnouncementCenter() {
  return get<AnnouncementCenterItem[]>('/announcements/all');
}

// 2. 管理员获取全部公告列表
export function getAdminAnnouncements() {
  return get<Announcement[]>('/admin/announcements');
}

// 3. 管理员发布新公告
export function createAnnouncement(payload: AnnouncementPayload) {
  return post<{ id: string }>('/admin/announcements', payload);
}

// 4. 管理员编辑更新公告
export function updateAnnouncement(id: string, payload: AnnouncementPayload) {
  return put<{ message: string }>(`/admin/announcements/${id}`, payload);
}

// 5. 管理员一键启用/停用公告
export function toggleAnnouncement(id: string) {
  return put<{ active: boolean }>(`/admin/announcements/${id}/toggle`);
}

// 6. 管理员删除公告 (软删除)
export function deleteAnnouncement(id: string) {
  return del<{ message: string }>(`/admin/announcements/${id}`);
}

// 7. 会员标记公告为已读
export function markAnnouncementAsRead(id: string) {
  return post<{ message: string }>(`/announcements/${id}/read`);
}

// 8. 会员批量标记所有公告为已读
export function markAllAnnouncementsAsRead(ids: string[]) {
  return post<{ message: string }>('/announcements/read-all', { ids });
}
